/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_No_MatchesInputs */

const en_messages_no_matches = /** @type {(inputs: Messages_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches.`)
};

const he_messages_no_matches = /** @type {(inputs: Messages_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין תוצאות.`)
};

/**
* | output |
* | --- |
* | "No matches." |
*
* @param {Messages_No_MatchesInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_no_matches = /** @type {((inputs?: Messages_No_MatchesInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_No_MatchesInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_no_matches(inputs)
	return he_messages_no_matches(inputs)
});